import React from 'react'

function PaymentLink({ reference }) {
    return <h1>Payment Link</h1>
}

export default PaymentLink
